import { TooltipProps } from "recharts";
import { formatHexCompactLabel } from "./format-hex";
import { formatUsdCompact } from "./format-price";

export type TooltipValueFormat = "number" | "hex" | "usd";

export type TooltipConfigOptions = TooltipProps<any, any> & {
  valueFormat?: TooltipValueFormat;
};

function formatTooltipValue(value: number, format: TooltipValueFormat) {
  if (!Number.isFinite(value)) return "—";
  if (format === "usd") return formatUsdCompact(value);
  if (format === "hex") return formatHexCompactLabel(value);
  return new Intl.NumberFormat("en").format(value);
}

export function tooltipConfig(options?: TooltipConfigOptions) {
  const { valueFormat = "number", ...rest } = options ?? {};

  return {
    labelFormatter: (value: string | number) => (
      <span className="inline-block pb-3 pt-1 text-base font-semibold text-white">
        Day {value}
      </span>
    ),
    formatter: (value: number) => formatTooltipValue(value, valueFormat),
    contentStyle: {
      backgroundColor: "#050505",
      borderRadius: "8px",
      borderColor: "#1B1D1D",
      padding: "8px 16px",
      color: "#fff",
      fontWeight: 600,
      fontSize: "14px",
    },
    ...rest,
  } as any;
}

export default tooltipConfig;
